import { mapObjectize } from 'cityads-v3/utils/apiUtils';
import {
  GET_LIST,
  GET_LIST_SUCCESS,
  GET_LIST_FAIL,
} from "../actions/currency";


const initialState = {
  currencyById: {
    1: {
      id: 1,
      name: 'RUB',
      complete_rate: 1,
      is_active: 1,
      is_manager_active: 1
    },
    2: {
      id: 2,
      name: 'USD',
      complete_rate: 1,
      is_active: 1,
      is_manager_active: 1
    },
    3: {
      id: 3,
      name: 'EUR',
      complete_rate: 1,
      is_active: 1,
      is_manager_active: 1
    },
    4: {
      id: 4,
      name: 'UAH',
      complete_rate: 1,
      is_active: 1,
      is_manager_active: 1
    },
    5: {
      id: 5,
      name: 'KZT',
      complete_rate: 1,
      is_active: 1,
      is_manager_active: 1
    },
    6: {
      id: 6,
      name: 'CNY',
      complete_rate: 1,
      is_active: 1,
      is_manager_active: 1
    },
    7: {
      id: 7,
      name: 'BRL',
      complete_rate: 1,
      is_active: 1,
      is_manager_active: 1
    },
    8: {
      id: 8,
      name: 'MXN',
      complete_rate: 1,
      is_active: 1,
      is_manager_active: 1
    },
    9: {
      id: 9,
      name: 'IDR',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    10: {
      id: 10,
      name: 'BND',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    11: {
      id: 11,
      name: 'KHR',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    12: {
      id: 12,
      name: 'LAK',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    13: {
      id: 13,
      name: 'MMK',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    14: {
      id: 14,
      name: 'PHP',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    15: {
      id: 15,
      name: 'SGD',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 1
    },
    16: {
      id: 16,
      name: 'THB',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    17: {
      id: 17,
      name: 'VND',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 1
    },
    18: {
      id: 18,
      name: 'KRW',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    19: {
      id: 19,
      name: 'AUD',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    20: {
      id: 20,
      name: 'NZD',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    21: {
      id: 21,
      name: 'MYR',
      complete_rate: 1,
      is_active: 1,
      is_manager_active: 1
    },
    22: {
      id: 22,
      name: 'COP',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    23: {
      id: 23,
      name: 'CLP',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    24: {
      id: 24,
      name: 'PLN',
      complete_rate: 1,
      is_active: 1,
      is_manager_active: 1
    },
    25: {
      id: 25,
      name: 'ARS',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    26: {
      id: 26,
      name: 'HKD',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    27: {
      id: 27,
      name: 'TWD',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    28: {
      id: 28,
      name: 'AED',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    29: {
      id: 29,
      name: 'BGN',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    30: {
      id: 30,
      name: 'BSD',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    31: {
      id: 31,
      name: 'CAD',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    32: {
      id: 32,
      name: 'CHF',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    33: {
      id: 33,
      name: 'CZK',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    34: {
      id: 34,
      name: 'DKK',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    35: {
      id: 35,
      name: 'EGP',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    36: {
      id: 36,
      name: 'GBP',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    37: {
      id: 37,
      name: 'HRK',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    38: {
      id: 38,
      name: 'HUF',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    39: {
      id: 39,
      name: 'ILS',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    40: {
      id: 40,
      name: 'INR',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    41: {
      id: 41,
      name: 'ISK',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    42: {
      id: 42,
      name: 'JPY',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    43: {
      id: 43,
      name: 'MAD',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    44: {
      id: 44,
      name: 'MUR',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    45: {
      id: 45,
      name: 'NOK',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    46: {
      id: 46,
      name: 'QAR',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    47: {
      id: 47,
      name: 'RON',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    48: {
      id: 48,
      name: 'SAR',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    49: {
      id: 49,
      name: 'SEK',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    50: {
      id: 50,
      name: 'TND',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    51: {
      id: 51,
      name: 'TRY',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    52: {
      id: 52,
      name: 'ZAR',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    53: {
      id: 53,
      name: 'RSD',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    54: {
      id: 54,
      name: 'BAM',
      complete_rate: 1,
      is_active: 1,
      is_manager_active: 1
    },
    55: {
      id: 55,
      name: 'MKD',
      complete_rate: 1,
      is_active: 1,
      is_manager_active: 1
    },
    56: {
      id: 56,
      name: 'BDT',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    57: {
      id: 57,
      name: 'GHS',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    58: {
      id: 58,
      name: 'KES',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    59: {
      id: 59,
      name: 'NGN',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    60: {
      id: 60,
      name: 'PKR',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    61: {
      id: 61,
      name: 'UGX',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    62: {
      id: 62,
      name: 'XAF',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    63: {
      id: 63,
      name: 'XOF',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    64: {
      id: 64,
      name: 'CDF',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    65: {
      id: 65,
      name: 'ETB',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    66: {
      id: 66,
      name: 'MGA',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    67: {
      id: 67,
      name: 'MZN',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    68: {
      id: 68,
      name: 'RWF',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    69: {
      id: 69,
      name: 'TZS',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
    70: {
      id: 70,
      name: 'ZMW',
      complete_rate: 1,
      is_active: 0,
      is_manager_active: 0
    },
  },
  currency: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "70"],
  isLoadingCurrency: false,
  isLoadedCurrency: false,
};

export default function currency(state = initialState, action = {}) {
  switch (action.type) {
    case GET_LIST:
      return {
        ...state,
        isLoadingCurrency: true,
        isLoadedCurrency: false,
      };
    case GET_LIST_SUCCESS:
      const currencyList = action.response.currency;
      const currency = currencyList.map(item => +item.id);
      const currencyById = mapObjectize(currencyList.map(item => ({
        ...item,
        id: +item.id,
        is_active: Boolean(Number(item.is_active)),
        is_manager_active: Boolean(Number(item.is_manager_active)),
      })), 'id');
      return {
        ...state,
        currency,
        currencyById: {
          ...state.currencyById,
          ...currencyById,
        },
        isLoadingCurrency: false,
        isLoadedCurrency: true,
      };
    case GET_LIST_FAIL:
      return {
        ...state,
        isLoadingCurrency: false,
        isLoadedCurrency: false,
      };

    default:
      return state;
  }
}
